export default __webpack_public_path__ + "static/media/shopeepayLogo.96523834.png";